import { render, staticRenderFns } from "./Labeltemplate.vue?vue&type=template&id=1a041cea&scoped=true"
import script from "./Labeltemplate.vue?vue&type=script&lang=js"
export * from "./Labeltemplate.vue?vue&type=script&lang=js"
import style0 from "./Labeltemplate.vue?vue&type=style&index=0&id=1a041cea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a041cea",
  null
  
)

export default component.exports